import styled from "@emotion/styled";
import { genericStyles } from "../../../constant";

export const StyledCalendarDiv = styled.div`
  .calendar-div {
    height: calc(100dvh - 20px);
    .rbc-header {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 30px;
    }
    .rbc-event {
      background-color: var(--primary) !important;
      border: none;
      justify-content: center;
    }
    .rbc-allday-cell {
      display: none;
    }
    .rbc-time-column .rbc-timeslot-group {
      min-height: 80px;
    }
  }
  .date-cell {
    position: absolute;
    top: 8px;
    padding-top: 20px;
    width: 90%;
    height: 100%;
  }

  .add-btn {
    font-size: 18px;
    color: ${genericStyles.primaryColor};
    position: absolute;
    top: 0;
    left: 5px;
    cursor: pointer;
    transition: opacity 0.2s ease-in-out;
  }

  .date-cell .add-btn {
    opacity: 0;
    pointer-events: none;
  }

  .date-cell:hover .add-btn {
    opacity: 1;
    pointer-events: auto;
  }

  .custom-scroll-container {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    height: calc(100% - 15px);
    gap: 4px;
    padding-right: 4px;

    /* Customize scrollbar */
    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: #d1d5db;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #9ca3af;
    }
  }

  .event-item {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    font-size: 14px;
    line-height: 1.2;
  }

  .event-dot {
    width: 6px;
    height: 6px;
    min-width: 6px;
    background-color: ${genericStyles.primaryColor};
    border-radius: 50%;
    flex-shrink: 0;
  }
`;
